import Debug from 'debug';
import * as React from 'react';
import { Option } from 'gossamer-unified';
import { FormControl } from './FormControl';

const debug = Debug('gfe/fi/ChecksGroup');

interface ChecksGroupProps {
  className?: string;
  clearOnSelection?: boolean; // TODO implement
  excludeValues?: string[];
  inline?: boolean;
  mandatory: boolean;
  onItemSelected: (newValue: string) => void;
  options: Option[];
  type: 'radio' | 'checkbox' | 'switch';
  validity?: boolean;
  value: string;
}

export const ChecksGroup = (props: ChecksGroupProps): React.JSX.Element => {
  // debug(`${props.type}, ${props.value}`);
  const name = React.useMemo(() => {
    const a = Math.random().toString(36).slice(2);
    const b = Math.random().toString(36).slice(2);
    return `cg_${a}${b}`;
  }, []);
  const inputType: 'radio' | 'checkbox' = props.type === 'switch' ? 'checkbox' : props.type;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    debug(event.target);
    const newVal = event.target.value;
    props.onItemSelected(newVal);
  };
  const options = props.options
    .filter((opt) => opt.active !== false && (!props.excludeValues || props.excludeValues.indexOf(opt.id) === -1))
    .map((opt) => (
      <div key={opt.id}>
        <input
          checked={props.value === opt.id}
          id={`${name}-${opt.id}`}
          name={name}
          onChange={handleChange}
          type={inputType}
          value={opt.id}
        />
        &nbsp;
        <label htmlFor={`${name}-${opt.id}`}>{opt.label}</label>
      </div>
    ));
  return (
    <FormControl className={props.className} flexDirection={props.inline ? 'row' : 'column'} validity={props.validity}>
      {options}
    </FormControl>
  );
};
